import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  container: {
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',
    padding: '24px 16px 40px',
  },
  title: {
    fontWeight: 700,
    fontSize: '22px',
    marginBottom: '20px',
  },
  addSection: {
    background: '#2C325C',
    borderRadius: '12px',
    padding: '20px 24px',
    marginBottom: '16px',
  },
  addForm: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    flexWrap: 'wrap' as any,
  },
  paper: {
    background: '#2C325C',
    borderRadius: '12px',
    overflow: 'hidden',
  },
  table: {
    '& .MuiTableHead-root .MuiTableCell-root': {
      borderBottom: '1px solid #ffffff15',
      color: '#ffffffcc',
      fontSize: '13px',
      fontWeight: 600,
      padding: '12px 16px',
    },
    '& .MuiTableBody-root .MuiTableCell-root': {
      borderBottom: '1px solid #ffffff08',
      padding: '10px 16px',
      fontSize: '13px',
    },
  },
  row: {
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: '#ffffff0a',
    },
  },
  addButton: {
    width: '40px',
    height: '40px',
  },
  input: {
    minWidth: '140px',
  },
});
